import React from 'react'
import { FormattedMessage } from 'react-intl'

const nbsp = <span>&nbsp;</span>

export const LANDING_STRONGHOLD_HEADER = (
    <FormattedMessage
        id='landing_stronghold.header'
        defaultMessage='Укрепрайон'
    />
)

export const LANDING_STRONGHOLD_MESSAGE1 = (
    <FormattedMessage
        id='landing_stronghold.message1'
        // eslint-disable-next-line max-len
        defaultMessage={'В Укрепрайонах кланы сражаются друг с другом. Результат противостояний во многом зависит от тактики и командной игры, а главная цель в этом режиме{nbsp}— подготовка клановых резервов, дающих бонус к опыту и кредитам.'}
        values={{
            nbsp,
        }}
    />
)

export const LANDING_STRONGHOLD_MESSAGE2 = (
    <FormattedMessage
        id='landing_stronghold_message2'
        // eslint-disable-next-line max-len
        defaultMessage={'Также в Укрепрайонах регулярно проводятся Военные игры{nbsp}— соревнования, в которых можно выиграть золото и клановые резервы высоких уровней.'}
        values={{
            nbsp,
        }}
    />
)


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingStronghold/translations.jsx